async function loadOrganizationData() {
  const filiaisContainer = document.querySelector("#filiais-container");
  filiaisContainer.innerHTML = "";

  showMyAccountSpinner(filiaisContainer);

  try {
    const organizations = await fetchWithCache(
      "organizations",
      getOrganizationData,
      globalCustomerId
    );
    renderOrganizationsData(organizations, filiaisContainer);
  } catch (error) {
    filiaisContainer.innerHTML = `
        <div class="dados">
          <span>Ocorreu um erro ao buscar as filiais associadas ao seu perfil.</span>
        </div>
      `;
  } finally {
    removeMyAccountSpinner(filiaisContainer);
  }
}